$(document).ready(function() {
    var t = "", e = "";
    var defaultCountry = "Saudi Arabia"; // Set the default country to Saudi Arabia

    // Set the default selected country and show the country list
    $(".selected-country").text(defaultCountry); // Set the text to 'SAUDI ARABIA'
    $(".country-list li[data-country='" + defaultCountry + "']").addClass("selected"); // Set the corresponding list item as selected
    $(".country-list").hide();

    // Function to handle country selection
    $(".selected-country").click(function() {
        $(".country-list").toggle();
    });

    $(".country-list li").click(function() {
        var n = $(this).data("country");
        t = "";
        $(".selected-country").text(n);
        $(".country-list").hide();
        $(".country-list li").removeClass("selected");
        $(this).addClass("selected");

        // Handle the country data
        updateCountryData(n); // Call the function with the selected country
    });

    // Function to update country-specific data (languages and currency)
    function updateCountryData(n) {
        var defaultCountry = "Saudi Arabia"; // Default country check
        var c = a[n] || [];
        var s = $(`.hidden_select a[data-country="${n}"]`);
        e = s.attr("href");
        $(".lang-select").empty();
        $(".p--crncy").empty();
        let l = "", o = false, r = false;

        c.forEach(function(t) {
            if (t.Language) {
                var e = "locale-" + t.Language.replace(/\s+/g, "_").toLowerCase();
                var a = ""; // Default unchecked

                // Only apply default checked logic for "SAUDI ARABIA"
                if (n === defaultCountry) {
                    if (window.location.href.includes("/ar") && t.Language === "ARABIC") {
                        a = "checked"; // Default to Arabic if in `/ar`
                    } else if (!window.location.href.includes("/ar") && t.Language === "ENGLISH") {
                        a = "checked"; // Default to English otherwise
                    }
                } else {
                    // For other countries, fallback to first language as default
                    if (!r) {
                        a = "checked";
                        r = true;
                    }
                }

                // Handle URL adjustments for language
                let currentUrl = window.location.href;
                let adjustedUrl = currentUrl;

                if (n === defaultCountry) {
                    if (t.Language === "ARABIC") {
                        // Add `/ar` if selecting Arabic
                        if (!currentUrl.includes('/ar')) {
                            let [baseUrl, ...rest] = currentUrl.split('.sa/');
                            adjustedUrl = `${baseUrl}.sa/ar/${rest.join('.sa/')}`;
                        }
                    } else if (t.Language === "ENGLISH") {
                        // Remove `/ar` if selecting English
                        adjustedUrl = currentUrl.replace('/ar', '');
                    }
                } else {
                    adjustedUrl = t.url; // For other countries, use static URLs
                }

                l += `
                    <div class="form-cstm-control">
                        <input value="${t.Language}" type="radio" class="input-dyc" id="${e}" name="language" ${a} data-url="${adjustedUrl}">
                        <label class="custom-lbl" for="${e}">
                            ${t.text}
                        </label>
                    </div>
                `;
                o = true;
            }
            if (t.money) {
                var currencyLabel = window.location.href.includes('/ar') ? 'عملة' : 'Currency';
                $(".p--crncy").html(`
                    <label class="curren-ttl-i1 lang-lbl">${currencyLabel}</label>
                    <p class="crs-mny">${t.text}</p>
                `);
            }
        });

        if (o) {
            // Check if the URL contains "/ar" to switch the language label
            var languageLabel = window.location.href.includes('/ar') ? 'لغة' : 'Language';

            $(".lang-select").append(`
                <label class="lang-ttl-i1 lang-lbl">${languageLabel}</label>
                ${l}
            `);

            $(".input-dyc").click(function() {
                t = $(this).data("url");
            });
        }

        $(".lang-select").is(":empty") ? $(".lang-select").hide() : $(".lang-select").show();
        $(".p--crncy").is(":empty") ? $(".p--crncy").hide() : $(".p--crncy").show();
    }

    // Add functionality for confirmcountry button
    $("#confirmcountry").click(function() {
        var selectedCountry = $(".selected-country").text().trim();
        
        // Check if the selected country has JSON data
        var countryData = a[selectedCountry];

        if (countryData && countryData.length > 0) {
            // If country has JSON data, navigate to the URL from the selected language
            var selectedUrl = $(".input-dyc:checked").data("url");
            if (selectedUrl) {
                window.location.href = selectedUrl;
            }
        } else {
            // If the country doesn't have JSON data (like Australia), use the `data-url` from the selected <li>
            var selectedLiUrl = $(".country-list li.selected").data("url");
            if (selectedLiUrl) {
                window.location.href = selectedLiUrl; // Navigate to the URL in the <li> element
            }
        }
    });

    // Hide country list if clicked outside
    $(document).click(function(t) {
        if (!$(t.target).closest(".slct-y-container").length) {
            $(".country-list").hide();
        }
    });
    // Default data for country selection
    const a = {
        "Saudi Arabia": [
            { Language: "ENGLISH", text: "ENGLISH", url: "https://maje.sa/" },
            { Language: "ARABIC", text: "عربي", url: "https://maje.sa/ar/" },
        ],
        "المملكة العربية السعودية": [
            { Language: "ENGLISH", text: "ENGLISH", url: "https://maje.sa/" },
            { Language: "ARABIC", text: "عربي", url: "https://maje.sa/ar/" },
        ],
        "Belgium": [
            { "Language": "FRANÇAIS", "text": "FRANÇAIS", "url": "https://be.maje.com/" },
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://be.maje.com/en/home/" },            
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "Canada": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://ca.maje.com/" },
            { "Language": "FRANÇAIS", "text": "FRANÇAIS", "url": "https://ca.maje.com/fr/home" },
            { "money": "CURRENCY", "text": "C$ - CANADIAN DOLLAR" }
        ],
        "Spain": [
            { "Language": "ESPAÑOL", "text": "ESPAÑOL", "url": "https://es.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "United States": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://us.maje.com/" },
            { "money": "CURRENCY", "text": "$ - US DOLLAR" }
        ],
        "Europe": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://eu.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "France": [
            { "Language": "FRANÇAIS", "text": "FRANÇAIS", "url": "https://fr.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "Germany": [
            { "Language": "DEUTSCH", "text": "DEUTSCH", "url": "https://de.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "Ireland": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://ie.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "Italy": [
            { "Language": "ITALIANO", "text": "ITALIANO", "url": "https://it.maje.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],       
        "United Kingdom": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://uk.maje.com/" },
            { "money": "CURRENCY", "text": "£ - POUND STERLING" }
        ],
        "Switzerland": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://ch.maje.com/" },           
            { "money": "CURRENCY", "text": "CHF - SWISS FRANC" }
        ],
    };

    updateCountryData(defaultCountry); 
});



// language drawer open
document.addEventListener('DOMContentLoaded', function() {
    var opnDrawers = document.querySelectorAll('[data-action="locale-drawer"]');
    var rightSidePopUp = document.querySelector('.right-side-pop-up');
    var closeDrawers = document.querySelectorAll('.close-drawer');

    function toggleBodyScroll(isOpen) {
        document.body.classList.toggle('no-scroll', isOpen);
        // document.body.classList.toggle('header-white', isOpen);
      if (!document.body.classList.contains('header-white')) {
          document.body.classList.toggle('header-white', isOpen);
      }
    }
    if (opnDrawers && rightSidePopUp) {
        opnDrawers.forEach(function(opnDrawer) {
            opnDrawer.addEventListener('click', function(event) {
                event.preventDefault();        
                if (opnDrawer.classList.contains('header_drawer-dd')) {
                    document.querySelector('#close-menu-drawer').click(); 
                }                  
                var isOpen = rightSidePopUp.classList.toggle('open');
                toggleBodyScroll(isOpen);
            });
        });
    }
    closeDrawers.forEach(function(closeDrawer) {
        closeDrawer.addEventListener('click', function() {
            if (rightSidePopUp) {
                rightSidePopUp.classList.remove('open');
                toggleBodyScroll(false);
            }
        });
    });
    document.addEventListener('click', function(event) {
        if (!rightSidePopUp.contains(event.target) && ![...opnDrawers].some(opnDrawer => opnDrawer.contains(event.target))) {
            rightSidePopUp.classList.remove('open');
            toggleBodyScroll(false);
        }
    });
});
// PDP Drawer
document.addEventListener('DOMContentLoaded', function() {
    var descDrwElements = document.querySelectorAll('.desc-drw');
    var rightSideDescription = document.querySelector('.right-side-description');
    var closeDrawerButtons = document.querySelectorAll('.close-desc-drawer');
    var prevButton = document.querySelector('.prev-a');
    var nextButton = document.querySelector('.next-a');
    var prevTitleSpan = document.querySelector('.prev-ttl');
    var nextTitleSpan = document.querySelector('.next-ttl');

    function toggleBodyScroll(isOpen) {
        document.body.classList.toggle('disable-scroll', isOpen);
    }
    function updateActiveDrawer(targetId) {
        var targetContent = document.querySelector('.drawer-p-description#' + targetId);

        // Close all drawer contents first
        document.querySelectorAll('.drawer-p-description').forEach(function(content) {
            content.classList.remove('active');
        });
        // Open the specific drawer content
        if (targetContent) {
            targetContent.classList.add('active');
        }
        rightSideDescription.classList.add('open-drawer');
        toggleBodyScroll(true);

        updateNavigationTitles();
    }
    function getCurrentIndex() {
        var activeElement = document.querySelector('.drawer-p-description.active');
        return Array.from(document.querySelectorAll('.drawer-p-description')).indexOf(activeElement);
    }

    function getElementByIndex(index) {
        return document.querySelectorAll('.drawer-p-description')[index];
    }

    function getTitleByIndex(index) {
        var element = getElementByIndex(index);
        return element ? element.querySelector('.drawer-name').textContent.trim() : '';
    }

    function updateNavigationTitles() {
        var currentIndex = getCurrentIndex();
        var totalElements = document.querySelectorAll('.drawer-p-description').length;
        // Update navigation titles
        var prevIndex = currentIndex > 0 ? currentIndex - 1 : null;
        var nextIndex = currentIndex < totalElements - 1 ? currentIndex + 1 : null;

        prevTitleSpan.textContent = prevIndex !== null ? getTitleByIndex(prevIndex) : '';
        nextTitleSpan.textContent = nextIndex !== null ? getTitleByIndex(nextIndex) : '';
        // Show/hide buttons based on the current index
        prevButton.style.display = prevIndex !== null ? 'flex' : 'none';
        nextButton.style.display = nextIndex !== null ? 'flex' : 'none';
    }
    if (descDrwElements.length > 0 && rightSideDescription) {
        // Open the drawer when an element with desc-drw class is clicked
        descDrwElements.forEach(function(element) {
            element.addEventListener('click', function(event) {
                event.preventDefault();
                var targetId = element.getAttribute('data-id');
                updateActiveDrawer(targetId);
            });
        });
    }

    if (closeDrawerButtons.length > 0) {
        // Close the drawer when any close button is clicked
        closeDrawerButtons.forEach(function(closeButton) {
            closeButton.addEventListener('click', function() {
                rightSideDescription.classList.remove('open-drawer');
                toggleBodyScroll(false);
                // Close all drawer contents
                document.querySelectorAll('.drawer-p-description').forEach(function(content) {
                    content.classList.remove('active');
                });
            });
        });
    }

    if (rightSideDescription) {
        // Close the drawer when clicking outside of it
        document.addEventListener('click', function(event) {
            if (!rightSideDescription.contains(event.target) && !Array.from(descDrwElements).some(element => element.contains(event.target))) {
                rightSideDescription.classList.remove('open-drawer');
                toggleBodyScroll(false);
                // Close all drawer contents
                document.querySelectorAll('.drawer-p-description').forEach(function(content) {
                    content.classList.remove('active');
                });
            }
        });
    }
    if (prevButton) {
        // Handle previous button click
        prevButton.addEventListener('click', function() {
            var currentIndex = getCurrentIndex();
            var prevIndex = (currentIndex > 0) ? currentIndex - 1 : null;
            var prevElement = getElementByIndex(prevIndex);

            if (prevElement) {
                var targetId = prevElement.getAttribute('id');
                updateActiveDrawer(targetId);
            }
        });
    }

    if (nextButton) {
        // Handle next button click
        nextButton.addEventListener('click', function() {
            var currentIndex = getCurrentIndex();
            var nextIndex = (currentIndex < descDrwElements.length - 1) ? currentIndex + 1 : null;
            var nextElement = getElementByIndex(nextIndex);

            if (nextElement) {
                var targetId = nextElement.getAttribute('id');
                updateActiveDrawer(targetId);
            }
        });
    }
});
// document.addEventListener('DOMContentLoaded', function() {
//     const descriptions = document.querySelectorAll('.description-dds');
//     const sMores = document.querySelectorAll('.s-more');   
//     function setupToggle(description, sMore) {
//         sMore.addEventListener('click', function() {
//             description.classList.add('expanded');
//             sMore.style.display = 'none';
//         });
//     }
//     descriptions.forEach((description, index) => {
//         setupToggle(description, sMores[index]);
//     });
// });



// Account Drawer

document.addEventListener('DOMContentLoaded', function() {
    var opnDrawers = document.querySelectorAll('[data-action="account-drawer"]');
    var sizeguidePopup = document.querySelector('.right-side-account-drawer');
    var closeDrawers = document.querySelectorAll('.close-sg-drawer');

    function toggleBodyScroll(isOpen) {
        document.body.classList.toggle('dont-scroll', isOpen);
    }

    if (sizeguidePopup) {
        if (opnDrawers.length > 0) {
            opnDrawers.forEach(function(opnDrawer) {
                opnDrawer.addEventListener('click', function(event) {
                    event.preventDefault();
                    if (opnDrawer.classList.contains('header_drawer-dd')) {
                        document.querySelector('#close-menu-drawer').click(); 
                    }
                    var isOpen = sizeguidePopup.classList.toggle('open');
                    toggleBodyScroll(isOpen);
                });
            });
        }

        if (closeDrawers.length > 0) {
            closeDrawers.forEach(function(closeDrawer) {
                closeDrawer.addEventListener('click', function() {
                    sizeguidePopup.classList.remove('open');
                    toggleBodyScroll(false);
                });
            });
        }

        document.addEventListener('click', function(event) {
            if (!sizeguidePopup.contains(event.target) && ![...opnDrawers].some(opnDrawer => opnDrawer.contains(event.target))) {
                sizeguidePopup.classList.remove('open');
                toggleBodyScroll(false);
            }
        });
    } 
});

// create account drawer
document.addEventListener('DOMContentLoaded', function() {
    const drawerButton = document.getElementById('ca-drawer');
    const drawer = document.querySelector('.ac--inner-drawer');
    const templateElement = document.getElementById('template');
    
    if (drawerButton && drawer && templateElement) {
        drawerButton.addEventListener('click', function() {
            drawer.classList.add('open');
            // Load the customer registration form
            // const templateContent = templateElement.innerHTML;
            // drawer.innerHTML = templateContent;
            
            // Add event listener to the 'Back' button after content is loaded
            const backButton = drawer.querySelector('.back-prev-pg');
            if (backButton) {
                backButton.addEventListener('click', function() {
                    // Remove the 'open' class to close the drawer
                    drawer.classList.remove('open');
                });
            }
        });
    }
});


// forgot password drawer

document.addEventListener('DOMContentLoaded', function() {
    const forgotPasswordLink = document.querySelector('.frgt-password');
    const backButtons = document.querySelectorAll('.back-pg-btn');
    const drawer = document.querySelector('.recover-yr-psw-drawer');

    if (forgotPasswordLink) {
        forgotPasswordLink.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent the default anchor behavior

            // Open the drawer by adding the 'open' class
            if (drawer) {
                drawer.classList.add('open');
            }
        });
    }

    if (backButtons.length > 0) {
        backButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                // Find the closest drawer to the clicked Back button and remove the 'open' class
                const closestDrawer = this.closest('.recover-yr-psw-drawer');
                if (closestDrawer) {
                    closestDrawer.classList.remove('open');
                }
            });
        });
    }
});

// Campagne page shop the look drawer
document.addEventListener("DOMContentLoaded", function () {
  const drawers = document.querySelectorAll(".cmp-right-side-drawer");
  const ctaButtons = document.querySelectorAll(".cta-fo-drawer");
  ctaButtons.forEach((cta) => {
    cta.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent link navigation

      const productId = this.getAttribute("product-id"); // Get product-id of the clicked button
      const matchingDrawer = Array.from(drawers).find((drawer) => {
        const productItem = drawer.querySelector(`.cmp-product-item[product-id="${productId}"]`);
        return productItem !== null;
      });

      if (matchingDrawer) {
        const overlay = matchingDrawer.querySelector(".cmp-drawer_overlay"); // Scoped overlay within the drawer

        matchingDrawer.classList.add("active");
        overlay?.classList.add("active");
        document.body.classList.add("dont-scroll");

        const productItems = matchingDrawer.querySelectorAll(".cmp-product-item");
        productItems.forEach((item) => item.classList.remove("show"));

        const matchingProduct = matchingDrawer.querySelector(`.cmp-product-item[product-id="${productId}"]`);
        if (matchingProduct) {
          matchingProduct.classList.add("show");
        }
      }
    });
  });

  // Attach close functionality to all drawers
  drawers.forEach((drawer) => {
    const overlay = drawer.querySelector(".cmp-drawer_overlay"); // Drawer-specific overlay
    const closeButtons = drawer.querySelectorAll(".close-drawer-icn"); // Drawer-specific close buttons
    if (overlay) {
      overlay.addEventListener("click", function () {
        closeDrawer(drawer, overlay);
      });
    }

    closeButtons.forEach((button) => {
      button.addEventListener("click", function () {
        closeDrawer(drawer, overlay);
      });
    });
  });

  function closeDrawer(drawer, overlay) {
    drawer.classList.remove("active");
    overlay?.classList.remove("active");
    document.body.classList.remove("dont-scroll");

    // Hide all product items within the current drawer
    const productItems = drawer.querySelectorAll(".cmp-product-item");
    productItems.forEach((item) => item.classList.remove("show"));
  }
});

// shop the look slider
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".cmp-swiper-slider").forEach((slider, index) => {
    new Swiper(slider, {
      loop: false,
      navigation: {
        nextEl: slider.querySelector(".swiper-next-btn"),
        prevEl: slider.querySelector(".swiper-prev-btn"),
      },
       pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true, 
      },
      slidesPerView: 1,
      spaceBetween: 0,
    });
  });
});


// faq accordion script
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".accordion-item-title").forEach(button => {
        button.addEventListener("click", function () {
            const faqItem = this.closest(".faq_accordion-item");
            faqItem.classList.toggle("open");
        });
    });

    function updateSteps(stepper, newLevel) {
        const allSteps = stepper.querySelectorAll(".acc-stepper-item");

        allSteps.forEach(step => {
            const stepLevel = parseInt(step.getAttribute("aria-level"));

            if (stepLevel === newLevel) {
                step.classList.add("open", "current");
                step.setAttribute("aria-expanded", "true");
            } else {
                step.classList.remove("open", "current");
                step.setAttribute("aria-expanded", "false");
            }
        });

        updateButtons(stepper, newLevel);
    }

    function updateButtons(stepper, currentLevel) {
        const allSteps = stepper.querySelectorAll(".acc-stepper-item");

        allSteps.forEach(step => {
            const stepLevel = parseInt(step.getAttribute("aria-level"));
            const prevButton = step.querySelector(".prev-step");
            const nextButton = step.querySelector(".next-step");

            if (prevButton) {
                prevButton.disabled = stepLevel === 1 || stepLevel !== currentLevel;
            }
            if (nextButton) {
                nextButton.disabled = stepLevel === allSteps.length || stepLevel !== currentLevel;
            }
        });
    }

    document.querySelectorAll(".accordion").forEach(accordion => {
        const stepper = accordion.querySelector(".stepper");

        if (!stepper) return;

        stepper.querySelectorAll(".next-step").forEach(button => {
            button.addEventListener("click", function () {
                const currentStep = stepper.querySelector(".acc-stepper-item.current");
                if (!currentStep) return;

                const currentLevel = parseInt(currentStep.getAttribute("aria-level"));
                const nextLevel = currentLevel + 1;
                if (stepper.querySelector(`.acc-stepper-item[aria-level="${nextLevel}"]`)) {
                    updateSteps(stepper, nextLevel);
                }
            });
        });

        stepper.querySelectorAll(".prev-step").forEach(button => {
            button.addEventListener("click", function () {
                const currentStep = stepper.querySelector(".acc-stepper-item.current");
                if (!currentStep) return;

                const currentLevel = parseInt(currentStep.getAttribute("aria-level"));
                const prevLevel = currentLevel - 1;
                if (stepper.querySelector(`.acc-stepper-item[aria-level="${prevLevel}"]`)) {
                    updateSteps(stepper, prevLevel);
                }
            });
        });

        // Initialize button states
        updateButtons(stepper, 1);
    });
});